import React from 'react';
import {
  Button, Card, CardContent, Grid, Box,
} from '@mui/material';
import { observer } from 'mobx-react';
import { AppGame } from '@gamiphy/bl/game';
import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { Trans, useDisplayStringValue } from '@gamiphy/react-i18n';
import { WelcomeGiftStore, WelcomeGiftTypes } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import { IntegrationsStore } from '@gamiphy/loyalty-station-desktop/store/integrations';

type Props = {
  appGame: AppGame,
}

const DraftGameCard: React.FC<Props> = observer(({ appGame }) => {
  const title = useDisplayStringValue(appGame.title);

  return (

    <Card>
      <CardContent>
        <Grid container sx={{ fontSize: '1.2rem' }} direction="column">
          <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 1 }} wrap="nowrap">
            <Grid container sx={{ mr: 1 }}>
              <Grid sx={{ mr: 0.5 }}>
                <Trans
                  i18nKey="draft.game.description"
                  defaults="Play {{game}}"
                  values={{
                    game: title,
                  }}
                />
              </Grid>
              {WelcomeGiftStore.type === WelcomeGiftTypes.points && (
              <Grid>
                (
                <Trans
                  i18nKey="gemsValue"
                  defaults="{{gems, gems}}"
                  values={{
                    gems: appGame.points.gems,
                  }}
                />
                )
              </Grid>
              )}
            </Grid>
            <Grid>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  fontSize: 'inherit',
                  width: '8rem',
                }}
                onClick={() => {
                  void IntegrationsStore.trackGTMEvent({ category: 'welcomeCoupon', action: 'gameClicked' });
                  UiStore.setPage(Pages.game);
                  UiStore.setShowGame(true);
                }}
              >
                <Trans
                  i18nKey="draft.game.play"
                  defaults="Play"
                  values={{}}
                />
              </Button>
            </Grid>
          </Grid>
          <Grid>
            <Box
              component="img"
              alt=""
              sx={{
                width: '100%',
                maxHeight: '10.4rem',
                objectFit: 'cover',
              }}
              src={appGame?.image}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

export default DraftGameCard;
